import { useMemo } from "react";

export type SearchWordsHook = string[];

export default function useSearchWords(query?: string): SearchWordsHook {
  const searchWords = useMemo(() => query?.split(" ") || [], [query]);

  return searchWords;
}
